import { render, staticRenderFns } from "./CommentsDialog.vue?vue&type=template&id=408ba421&"
import script from "./CommentsDialog.vue?vue&type=script&lang=js&"
export * from "./CommentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QCardSection,QList,QItem,QItemSection,QAvatar,QItemLabel,QInput,QInnerLoading,QSpinner,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QCardSection,QList,QItem,QItemSection,QAvatar,QItemLabel,QInput,QInnerLoading,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup,Ripple})
